/* NOJE - mobile sticky Add to Cart (self-contained).
   The theme ships sticky-add-to-cart assets but main-product.liquid never renders the snippet.
   Adds via /cart/add.js, refreshes the side cart via the theme's own path, then opens the drawer. */
(function () {
  if (window.__nojeStickyATC) return;
  window.__nojeStickyATC = true;

  var BREAKPOINT = 767;
  var tries = 0;

  function refreshSidebar() {
    if (window.Shopify && typeof window.Shopify.getCart === 'function') {
      window.Shopify.getCart(function (cart) {
        if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
          window.sharedFunctions.updateSidebarCart(cart);
        }
      });
      return true;
    }
    return false;
  }

  function openDrawer() {
    var t = document.querySelector('[data-cart-sidebar]');
    if (!t) return;
    setTimeout(function () { try { t.click(); } catch (e) {} }, 350);
  }

  function findTarget() {
    var forms = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      var idi = f.querySelector('[name="id"]');
      var btn = f.querySelector('[name="add"], button[type="submit"], input[type="submit"]');
      if (idi && btn && f.offsetParent !== null) return { form: f, idInput: idi, btn: btn };
    }
    return null;
  }

  function build(t) {
    if (document.getElementById('noje-sticky-atc')) return;

    var titleEl = document.querySelector('h1');
    var title = titleEl ? titleEl.textContent.trim() : '';

    var bar = document.createElement('div');
    bar.id = 'noje-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="noje-satc__meta">' +
        '<span class="noje-satc__title"></span>' +
        '<span class="noje-satc__price"></span>' +
      '</div>' +
      '<button type="button" class="noje-satc__btn">' +
        '<span class="noje-satc__idle"></span>' +
        '<span class="noje-satc__done" aria-hidden="true">&#10003;</span>' +
      '</button>';

    bar.querySelector('.noje-satc__title').textContent = title;
    var label = (t.btn.textContent || '').trim() || 'Add to cart';
    bar.querySelector('.noje-satc__idle').textContent = label;

    document.body.appendChild(bar);
    var btn = bar.querySelector('.noje-satc__btn');

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      var variantId = parseInt(t.idInput.value, 10);
      if (!variantId) return;
      var qtyEl = t.form.querySelector('[name="quantity"]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;

      btn.classList.add('is-loading');
      btn.setAttribute('disabled', 'disabled');

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
        .then(function (res) {
          return res.json().then(function (d) {
            if (!res.ok) throw new Error((d && (d.description || d.message)) || 'Add to cart failed');
            return d;
          });
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('disabled');
          btn.classList.add('is-added');
          if (!refreshSidebar()) { window.location.reload(); return; }
          openDrawer();
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('disabled');
          if (window.console) console.error('[noje sticky atc]', err && err.message ? err.message : err);
        });
    });

    function show() { if (window.innerWidth <= BREAKPOINT) { bar.classList.add('is-visible'); bar.setAttribute('aria-hidden', 'false'); } }
    function hide() { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) hide(); else show(); });
      }, { threshold: 0 }).observe(t.btn);
    } else {
      window.addEventListener('scroll', function () {
        var r = t.btn.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) show(); else hide();
      }, { passive: true });
    }
    window.addEventListener('resize', function () { if (window.innerWidth > BREAKPOINT) hide(); });
  }

  function init() {
    if (window.location.pathname.indexOf('/products/') === -1) return;
    var t = findTarget();
    if (t) { build(t); return; }
    if (++tries < 40) setTimeout(init, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();